import BrandLogo from "../../../common/ui/BrandLogo.js";

export default function OrderStatusNavigation(props) {
    return (
        <header className="wo-ordNav">
            <div className="wo-ordNav__inner">
                {/* ⚠ RESTORED 8 Oct. The redesign dropped the brand logo from this
                    header and replaced it with the words "Your order" — so the one
                    page a customer lands on AFTER paying was the only unbranded
                    page on the site. Missed on the first pass because the
                    tree-wide BrandLogo count still matched: references added in
                    BrandLogo.js itself happened to cover the two lost here.

                    No websiteConfig prop, so this falls back to the build-time
                    BrandLogo_<BRAND>.png, same as CartNavigation. Passing the
                    uploaded logo down the order-status route is the follow-up —
                    see PORT-NOTES §5d. */}
                <span className="wo-ordNav__logo"><BrandLogo /></span>
                <span className="wo-ordNav__title">Your order</span>
                <button type="button" className="wo-ordNav__new" onClick={props.handleStartNewOrderClickOrderStatus}>
                    Start new order
                </button>
            </div>
        </header>
    )
}